import { render } from "./PowerupsV4Modal.vue?vue&type=template&id=f432967e&scoped=true"
import script from "./PowerupsV4Modal.vue?vue&type=script&lang=js"
export * from "./PowerupsV4Modal.vue?vue&type=script&lang=js"

import "./PowerupsV4Modal.vue?vue&type=style&index=0&id=f432967e&scoped=true&lang=css"
import "./PowerupsV4Modal.vue?vue&type=style&index=1&id=f432967e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f432967e"]])

export default __exports__